import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "dealer-details",
    class: "dealer-details"
};
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { class: "title--one" };
const _hoisted_4 = { class: "title--two" };
const _hoisted_5 = { class: "title--three" };
const _hoisted_6 = { class: "title--four" };
const _hoisted_7 = { class: "title--five" };
const _hoisted_8 = { class: "score-container" };
const _hoisted_9 = { class: "score-container__average-score h3" };
const _hoisted_10 = { class: "score-container__all-reivews-text h3" };
const _hoisted_11 = { class: "score-container__all-reviews-stars" };
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "validation-comment" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title[0]), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title[1]), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title[2]), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title[3]), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.title[4]), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.averageScoreText), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.allReviewsText), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("img", {
                        src: _ctx.totalReviewsAverageStars.starOneImagePath
                    }, null, 8 /* PROPS */, _hoisted_12),
                    _createElementVNode("img", {
                        src: _ctx.totalReviewsAverageStars.starTwoImagePath
                    }, null, 8 /* PROPS */, _hoisted_13),
                    _createElementVNode("img", {
                        src: _ctx.totalReviewsAverageStars.starThreeImagePath
                    }, null, 8 /* PROPS */, _hoisted_14),
                    _createElementVNode("img", {
                        src: _ctx.totalReviewsAverageStars.starFourImagePath
                    }, null, 8 /* PROPS */, _hoisted_15),
                    _createElementVNode("img", {
                        src: _ctx.totalReviewsAverageStars.starFiveImagePath
                    }, null, 8 /* PROPS */, _hoisted_16)
                ])
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.validationComment), 1 /* TEXT */)
        ])
    ]));
}
